import { proxy } from "valtio";

const global = {
    isNewsModalOpen: false,
};

export const globalProxy = proxy(global);
